/* src/app/private/configrations/form-builder/create-form/create-form.component.scss */
.create-form-container .form-builder-layout {
  min-height: 70vh;
}
.create-form-container .field-list {
  min-height: 200px;
}
.create-form-container .field-item {
  transition: all 0.2s ease;
}
.create-form-container .field-item:hover {
  transform: translateY(-2px);
  border-color: #3b82f6;
}
.create-form-container .form-row {
  transition: all 0.3s ease;
}
.create-form-container .form-row:hover {
  background-color: #f9fafb;
}
.create-form-container .drop-zone {
  min-height: 120px;
  padding: 0.75rem;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
}
.create-form-container .drop-zone.empty-drop-zone {
  background-color: #fefefe;
  border: 2px dashed #d1d5db;
}
.create-form-container .drop-zone.cdk-drop-list-dragging {
  background-color: #eff6ff;
  border: 2px dashed #3b82f6;
}
.create-form-container .empty-drop-message {
  background-color: #f9fafb;
}
.create-form-container .field-card {
  position: relative;
  transition: all 0.2s ease;
  min-height: 100px;
}
.create-form-container .field-card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
.create-form-container .field-card:hover .drag-handle {
  opacity: 1;
}
.create-form-container .field-card.cdk-drag-preview {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2);
  border-color: #3b82f6;
  background-color: white;
  opacity: 0.9;
}
.create-form-container .field-card.cdk-drag-placeholder {
  opacity: 0.4;
  border: 2px dashed #9ca3af;
  background-color: #f3f4f6;
}
.create-form-container .field-card.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.create-form-container .drag-handle {
  opacity: 0.5;
  transition: opacity 0.2s ease;
}
.create-form-container .drag-handle:hover {
  opacity: 1;
}
.create-form-container .field-preview {
  border-top: 1px solid #e5e7eb;
  padding-top: 0.5rem;
  margin-top: 0.5rem;
}
.create-form-container ::ng-deep .row-columns-select .p-select {
  font-size: 0.875rem;
}
.create-form-container .cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.create-form-container .cdk-drop-list-dragging .cdk-drag {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}
.overflow-y-auto::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
.overflow-y-auto::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}
.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
/*# sourceMappingURL=create-form.component.css.map */
